import apiClient from './apiClient';

export async function listUsers(params = {}) {
  const res = await apiClient.get('/users', { params });
  return res.data.data;
}

export async function createUser(payload) {
  const res = await apiClient.post('/users', payload);
  return res.data.data;
}

export async function updateUser(userId, payload) {
  const res = await apiClient.put(`/users/${userId}`, payload);
  return res.data.data;
}

export async function setUserStatus(userId, status) {
  const res = await apiClient.patch(`/users/${userId}/status`, { status });
  return res.data.data;
}

export async function deleteUser(userId) {
  const res = await apiClient.delete(`/users/${userId}`);
  return res.data.data;
}

export async function resetUserPassword(userId, newPassword) {
  const res = await apiClient.post(`/users/${userId}/reset-password`, { newPassword });
  return res.data.data;
}

export async function getUserPermissions(userId) {
  const res = await apiClient.get(`/users/${userId}/permissions`);
  return res.data.data;
}

export async function setUserPermissions(userId, payload) {
  const res = await apiClient.put(`/users/${userId}/permissions`, payload);
  return res.data.data;
}

export async function listRefPartyAccess() {
  const res = await apiClient.get('/users/ref-party-access');
  return res.data.data;
}

export async function setUserRefParty(userId, refPartyId) {
  const res = await apiClient.patch(`/users/${userId}/ref-party`, { refPartyId });
  return res.data.data;
}

export async function setUserWatermark(userId, enabled) {
  const res = await apiClient.patch(`/users/${userId}/watermark`, { enabled });
  return res.data.data;
}

export async function listRoles() {
  const res = await apiClient.get('/roles');
  return res.data.data;
}
